import { useAuthUser } from "react-auth-kit";
import { Navigate } from "react-router-dom";

const PermissionsGate = ({ children, foundRedirect = null, scopes = [] }) => {
  const useAuth = useAuthUser();
  const auth = useAuth();

  let permissionGranted =
    auth?.roles &&
    scopes
      .toString()
      .split(".")
      .reduce((obj, i) => obj?.[i], auth?.roles);

  if (!permissionGranted && !foundRedirect) return <></>;

  if (!permissionGranted && foundRedirect) return <Navigate to="/Insights" />;

  return <>{children}</>;
};

export default PermissionsGate;
